export default __webpack_public_path__ + "static/media/grap.1caaa5b3.png";